
<!-- ① Floating draggable icon — visible when bar & dock are both closed -->
<div *ngIf="isBarMinimized && !isDockOpen"
     class="chatbot-icon-float"
     [class.chatbot-icon-float--positioned]="isPositioned"
     [style.left.px]="isPositioned ? iconX : null"
     [style.top.px]="isPositioned ? iconY : null"
     (pointerdown)="onPointerDown($event)"
     (pointermove)="onPointerMove($event)"
     (pointerup)="onPointerUp($event)"
     (pointercancel)="onPointerUp($event)">

  <button
    class="btn p-0 border-0 d-inline-flex align-items-center justify-content-center rounded-circle bg-transparent chat-ask-btn"
    type="button"
    aria-label="Open Ask Aikosh"
    matTooltip="Ask Aikosh"
    matTooltipPosition="left"
  >
    <span class="chat-ask-btn__logo-wrap">
      <span class="chat-ask-btn__ripple"></span>
      <span class="chat-ask-btn__ripple chat-ask-btn__ripple--delay1"></span>
      <span class="chat-ask-btn__ripple chat-ask-btn__ripple--delay2"></span>
      <img src="images/Chatbot-Logo.svg" alt="Ask Aikosh" width="44" height="44" />
    </span>
  </button>
</div>

<!-- ② Textarea bar — always at original fixed bottom-right, opens on icon tap -->
<div
  class="chat-entry-bar"
  *ngIf="!isBarMinimized && !isDockOpen"
>
  <div class="chat-entry-bar__wrap position-relative bhashini-skip-translation"
       (click)="onBarClick()">

    <!-- Close × — visible on hover of the wrap -->
    <button
      class="chat-entry-bar__close-btn position-absolute btn p-0 border-0 d-flex align-items-center justify-content-center"
      (click)="$event.stopPropagation(); closeBar()"
      type="button"
      title="Close"
      aria-label="Close chat"
    >
      &#x2715;
    </button>

    <app-textarea-input
      inputId="chat-entry-input"
      label="noLabel"
      [control]="queryControl"
      placeholder="Ask a question..."
      [rows]="2"
      (keydown)="onEnterKeyFn($any($event))"
    ></app-textarea-input>

    <button
      class="btn chat-entry-bar__send-btn position-absolute d-flex align-items-center justify-content-center"
      [disabled]="!queryControl.value?.trim() || queryControl.invalid"
      (click)="submit()"
      type="button"
      title="Send"
      aria-label="Send message"
    >
      <img
        [src]="getSendIconSrc(!!queryControl.value?.trim())"
        alt="send"
        width="30"
        height="30"
      />
    </button>
  </div>
</div>
